import { render, staticRenderFns } from "./fire.vue?vue&type=template&id=16554d4a"
import script from "./fire.vue?vue&type=script&lang=js"
export * from "./fire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports